import type { FC } from "react";

import styled from "styled-components";

import { isNoTouchOrTrialOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/trialUsersUtils";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import SearchCompetitorsWidget from "./components/SearchCompetitorsScatter/SearchCompetitorsWidget";
import SearchCarousel from "./components/SearchOverviewCarousel/SearchCarousel";
import TopNonBrandedKeywordsTable from "./components/TopNonBrandedKeywordsTable/TopNonBrandedKeywordsTable";
import TopPaidLandingPages from "./components/TopPaidLandingPages/TopPaidLandingPages";
import { SearchOverviewGraphConnected } from "./SearchOverviewGraph/SearchOverviewGraph";

const SearchOverviewSingleWrapper = styled(FlexColumn)`
    gap: 24px;
`;

const SearchOverviewSingle: FC = () => {
    const showSearchCompetitorsScatter = !isNoTouchOrTrialOrAfterTrial();

    return (
        <SearchOverviewSingleWrapper data-automation="SearchOverviewSingle">
            <SearchCarousel />
            <SearchOverviewGraphConnected />
            <TopNonBrandedKeywordsTable />
            <TopPaidLandingPages /> {showSearchCompetitorsScatter ? <SearchCompetitorsWidget /> : null}
        </SearchOverviewSingleWrapper>
    );
};

export default SearchOverviewSingle;
